import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getIsNativePlatform } from 'utils/platform';

import { selectLenderOfRecordIdentity } from 'store/auth/selectors';

import {
  EQUAL_HOUSING_LABEL,
  NMLS_PREFIX,
  POWERED_BY_HREF,
  POWERED_BY_LABEL,
} from './BrandingFooter.constants';
import {
  getIdentityTextSx,
  getPoweredByStyles,
  getRootStyles,
  identityStyles,
} from './BrandingFooter.styles';

const BrandingFooter = ({ isOverlay = false }) => {
  const { legalName, nmlsId } = useSelector(selectLenderOfRecordIdentity);

  const hasIdentity = !!legalName || !!nmlsId;
  const textColor = isOverlay ? 'common.white' : 'text.secondary';
  const identityTextSx = getIdentityTextSx(isOverlay);

  // In the native mobile shell the "Powered by Lender Optimus" co-brand is
  // suppressed. With no regulatory identity to show (e.g. the login overlay)
  // the footer has nothing left to render.
  const isNativePlatform = getIsNativePlatform();

  if (isNativePlatform && !hasIdentity) {
    return null;
  }

  return (
    <Box component="footer" sx={getRootStyles(isOverlay)}>
      <Box sx={identityStyles}>
        {legalName && (
          <Typography color={textColor} sx={identityTextSx} variant="regular12">
            {legalName}
          </Typography>
        )}
        {nmlsId && (
          <Typography color={textColor} sx={identityTextSx} variant="regular12">
            {`${NMLS_PREFIX}${nmlsId}`}
          </Typography>
        )}
        {hasIdentity && (
          <Typography color={textColor} sx={identityTextSx} variant="regular12">
            {EQUAL_HOUSING_LABEL}
          </Typography>
        )}
      </Box>

      {!isNativePlatform && (
        <Typography
          component="a"
          href={POWERED_BY_HREF}
          rel="noopener noreferrer"
          sx={getPoweredByStyles(isOverlay)}
          target="_blank"
          variant="medium12"
        >
          {POWERED_BY_LABEL}
        </Typography>
      )}
    </Box>
  );
};

BrandingFooter.propTypes = {
  isOverlay: PropTypes.bool,
};

export default memo(BrandingFooter);
